import { useSelector } from 'react-redux';

// Server-detected device type (set from the request's user-agent in
// server/render.js, stored at state.user.deviceType) is available
// identically during SSR and the first client render, unlike a viewport
// check which needs to wait for mount - see useViewportMatch's
// initialValue param for pairing the two.
export default function useIsDesktopDevice() {
	const deviceType = useSelector((state) => state.user?.deviceType);
	return deviceType === 'desktop';
}
